import { ContentRepository } from "src/modules/cms/repositories/ContentRepository";
import { GetContentByIdUseCase } from "src/modules/cms/use_cases/GetContentByIdUseCase";

export function makeGetContentById() {
  const contentRepository = new ContentRepository()
  return new GetContentByIdUseCase(contentRepository)
}
 